import React from 'react';
import { ToggleRight, ToggleLeft } from 'lucide-react';

export default function MinimalistToggle({ title, checked, onChange, disabled = false, titlePosition = 'left' }) {
  return (
    <div className="flex items-center space-x-2">
      {titlePosition === 'left' && <span className="text-xs text-gray-600 font-medium">{title}</span>}
      <button
        type="button"
        onClick={() => {
          if (!disabled) {
            onChange(!checked);
          }
        }}
        disabled={disabled}
        className={`flex items-center transition-colors duration-200 
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'}`}
      >
        {checked ? (
          <ToggleRight className="w-6 h-6" style={{ color: '#342c82' }} />
        ) : (
          <ToggleLeft className="w-6 h-6 text-gray-400" />
        )}
      </button>
      {titlePosition === 'right' && <span className="text-xs text-gray-600 font-medium">{title}</span>}
    </div>
  );
}
